import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { CATEGORIES, BLOG_URL } from "../data/categories";

function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const isActive = (path) => {
    return location.pathname === path ? "active" : "";
  };

  const closeMenu = () => setMenuOpen(false);

  return (
    <>
      {/* Animated Barber Pole Stripe */}
      <div className="barber-pole"></div>

      {/* Site Header */}
      <header className="site-header">
        <div className="site-logo">
          <Link to="/">
            <img src="/logo.png" alt="How To Bachelor" width="742" height="570" />
          </Link>
        </div>
        <h1 className="site-title">
          <Link to="/">How To Bachelor</Link>
        </h1>
        <p className="site-description">Your Bachelor's Guidebook</p>
      </header>

      {/* Main Navigation */}
      <nav className="main-navigation">
        <button
          className={`menu-toggle ${menuOpen ? "active" : ""}`}
          aria-label="Toggle navigation menu"
          aria-expanded={menuOpen}
          onClick={toggleMenu}
        >
          <div className="hamburger">
            <span></span>
            <span></span>
            <span></span>
          </div>
        </button>
        <ul className={`nav-menu ${menuOpen ? "active" : ""}`}>
          <li>
            <Link to="/" className={isActive("/")} onClick={closeMenu}>
              Home
            </Link>
          </li>

          {/* Category links all live on the blog - see src/data/categories.js */}
          {CATEGORIES.map((category) => (
            <li key={category.slug}>
              <a
                href={category.url}
                target="_blank"
                rel="noopener noreferrer"
                onClick={closeMenu}
              >
                {category.name}
              </a>
            </li>
          ))}

          <li>
            <a
              href={BLOG_URL}
              target="_blank"
              rel="noopener noreferrer"
              onClick={closeMenu}
            >
              All Articles
            </a>
          </li>
          <li>
            <Link
              to="/about"
              className={isActive("/about")}
              onClick={closeMenu}
            >
              About
            </Link>
          </li>
        </ul>
      </nav>
    </>
  );
}

export default Header;
